import React from 'react'
import ApiTokenListCard from '@/components/ApiTokenListCard'

export default function OrganizationApiTokens() {
    return <ApiTokenListCard />
}
